import React from 'react';
import {
  Copy,
  Flex,
  Image,
  Link,
  Stack,
  Container,
  Badge,
} from '@grubhubprod/gh-cookbook-react';
import { getWindow } from 'src/utilities/window';
import { GRUBHUB_PLUS_LABEL, SEAMLESS_PLUS_LABEL } from 'src/constants/brands';
import { Brands } from 'src/utilities/shared-types';

export const CLOUDINARY_BASE =
  'https://res.cloudinary.com/grubhub-assets/image/upload/v1588182979/subscriptions/Web%20-%20GH%2B%20Assets';

export const FAQ_PATH =
  '/help/contact-us/membership-benefits/4HreEuV5Y8pwlGGfQVASav';

export interface BrandConfig {
  image: string;
  label: string;
}

export function getBrandConfig(brand: string): BrandConfig {
  switch (brand?.toUpperCase()) {
    case Brands.SEAMLESS:
      return {
        image: `${CLOUDINARY_BASE}/Account_Seamless_Logo.svg`,
        label: SEAMLESS_PLUS_LABEL,
      };
    case Brands.GRUBHUB:
    default:
      return {
        image: `${CLOUDINARY_BASE}/Account_Grubhub_Logo.svg`,
        label: GRUBHUB_PLUS_LABEL,
      };
  }
}

export interface SubscriptionBannerProps {
  brand: string;
}

export function SubscriptionBanner({
  brand,
}: SubscriptionBannerProps): JSX.Element {
  const { image: headerImageSrc, label: brandLabel } = getBrandConfig(brand);
  const faqUrl = `${getWindow().location?.origin ?? ''}${FAQ_PATH}`;

  return (
    <Container variant="default">
      <Stack y="x-sm">
        <Flex alignItems="center" justifyContent="space-between">
          <Image
            src={headerImageSrc}
            alt={brandLabel}
            data-testid="subscription-banner-logo"
          />
          <Badge flavor="light" label="Active" />
        </Flex>
      </Stack>

      <Stack y="x-sm">
        <Copy variant="body">
          Employees enjoy unlimited free delivery, added rewards, and more!
        </Copy>
      </Stack>
      <Stack y="x-sm">
        <Copy variant="caption" color="secondaryText">
          For questions, contact your Client Success Manager or visit our{' '}
          <Link
            href={faqUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="subscription-banner-faq-link"
          >
            FAQ page
          </Link>
        </Copy>
      </Stack>
    </Container>
  );
}
